/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AfterViewInit, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core'
import { isString } from '../utils/core.utils'

@Directive({
  selector: '[dynamicList]',
  standalone: false,
})
export class DynamicListDirective implements AfterViewInit {
  private elementRef = inject(ElementRef)
  private renderer = inject(Renderer2)

  @Input('dynamicList') listId: string | null = null

  ngAfterViewInit() {
    if (isString(this.listId)) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'list', this.listId as string)
    }
  }
}
